<script>
import styled from "vue-styled-components";

const CookieBannerBody = styled.div`
  overflow-y: auto;

  a {
    color: ${props => props.theme.linkColor};
    text-decoration: underline;
  }
`;

export default CookieBannerBody;
</script>
